import { Pipe, PipeTransform } from '@angular/core';

import { ProspectSource } from '@gi/enums/prospect-source.enum';
import { UserBase } from '@models/user-base';

@Pipe({
  name: 'prospectCreatedBy',
  standalone: true
})
export class ProspectCreatedByPipe implements PipeTransform {
  transform(source: ProspectSource, user: UserBase): string {
    if (source && source === ProspectSource.external) {
      return 'Système';
    }

    return user?.fullName ?? '';
  }
}
